import { JSX, useContext } from "react";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import MegaMenuHeader from "@app/layout/menus/MegaMenuHeader";
import MegaMenuLink from "@app/layout/menus/MegaMenuLink";
import { DeploymentEnvironmentConstants } from "@app/shared/constants";
import { UserContext } from "@app/user/UserContext";
import { ClientType } from "@app/client/client";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function ManageMenu(): JSX.Element {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
  const userContext = useContext(UserContext);
  const isProd = window.environment === DeploymentEnvironmentConstants.Production;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Manage" />
        <ul className="menu">
          <RoleRestricted requiredRoles={[Roles.VOLUME_TERMINATOR, Roles.TERM_PROVIDER_ADMIN]}>
            <MegaMenuLink menuItem={MenuItemEnum.Termination} faIcon="user-times" to="/terminations/view" linkText="Termination" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.VOLUME_TARGET]}>
            <MegaMenuLink menuItem={MenuItemEnum.Targeting} faIcon="bullseye" to="/targeting/view" linkText="Targeting" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.QUEST_USER, Roles.CLIENT_ADMIN]}>
            <MegaMenuLink menuItem={MenuItemEnum.EditProjects} faIcon="pencil-square-o" to="/projects/edit" linkText="Edit Projects" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.CLIENT_ADMIN]}>
            <MegaMenuLink menuItem={MenuItemEnum.ManageTags} faIcon="tags" to="/tags/view" linkText="Tags" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.EXCEPTION_MANAGER]}>
            <MegaMenuLink menuItem={MenuItemEnum.Exceptions} faIcon="flag" to="/exceptions/view" linkText="Exceptions" />
          </RoleRestricted>
          {featureFlags.has(Features.ADEQUACY_REPORT_CUSTOMIZATION) && (
            <MegaMenuLink menuItem={MenuItemEnum.ReportPresets} faIcon="download" to="/report-presets" linkText="Report Presets" />
          )}
          {featureFlags.has(Features.TWOSIDED_ISSUER_WORKFLOW) &&
           userContext?.clientType === ClientType.Issuer &&
           !!userContext?.regulatorClientIds?.length && (
            <MegaMenuLink menuItem={MenuItemEnum.NetworkSubmission} faIcon="folder" to="/network-submission/view" linkText={`Compliance Connect${isProd ? "" : " (Issuer)"}`} />
          )}
          {featureFlags.has(Features.TWOSIDED_MARKETPLACE_REGULATOR) && (
            <MegaMenuLink menuItem={MenuItemEnum.ComplianceConnect} faIcon="list-alt" to="/compliance-connect" linkText={`Compliance Connect${isProd ? "" : " (Regulator)"}`} />
          )}
        </ul>
      </li>
    </ul>
  );
}
